<template>
  <div class="container">
    <div class="alert-details">
      <div class="alert-details__top">
        <div class="alert-details__patient-avatar">
          <div
            class="alert-details__patient-avatar-image"
            :style="userPhoto(alertData.user.photo)"
          />
        </div>

        <div class="alert-details__patient-info">
          <h4 class="alert-details__patient-name">{{ alertData.user.name }}</h4>
          <span>{{ alertData.user.email }}</span>
        </div>
      </div>

      <div class="alert-details__infor">
        <ul class="alert-details__infor-list">
          <li class="alert-details__infor-item">
            <span>Idade:</span>
            <h6>
              {{ formattedAge(alertData.user.birthday) || "Não definido" }}
            </h6>
          </li>

          <li class="alert-details__infor-item">
            <span>Peso:</span>
            <h6>
              {{ formattedWeight(alertData.user.weight) || "Não definido" }}
            </h6>
          </li>

          <li class="alert-details__infor-item">
            <span>Altura:</span>
            <h6>
              {{ formattedHeight(alertData.user.height) || "Não definido" }}
            </h6>
          </li>

          <li class="alert-details__infor-item">
            <span>Tipo sanguineo:</span>
            <h6>{{ alertData.user.blood_type || "Não definido" }}</h6>
          </li>

          <li class="alert-details__infor-item">
            <span>Grupo de risco:</span>
            <h6>{{ patientRisk(alertData.user.higher_risk) }}</h6>
          </li>

          <li class="alert-details__infor-item">
            <span>Telefone:</span>
            <h6>{{ alertData.user.phone_number || "Não definido" }}</h6>
          </li>
        </ul>
      </div>

      <div class="alert-details__description">
        <h4 class="alert-details__description-title">
          <Icon :name="'alert-icon'" :width="16" :height="16" />
          Pedido emergencial
        </h4>
        <p class="alert-details__description-text">
          {{ alertData.message || "Nenhuma descrição foi informada." }}
        </p>
      </div>

      <div class="alert-details__location">
        <GmapMap
          class="alert-details__location-map"
          :center="alertLocation(alertData)"
          :zoom="14"
        >
          <GmapCustomMarker
            :marker="alertLocation(alertData)"
            :clickable="false"
          >
            <div class="custom-marker">
              <div class="custom-marker__marker" />
              <div
                class="custom-marker__image"
                :style="userPhoto(alertData.user.photo)"
              />
            </div>
          </GmapCustomMarker>
        </GmapMap>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import Icon from "../components/CustomIcons";
import GmapCustomMarker from "vue2-gmap-custom-marker";

Vue.use(VueGoogleMaps, {
  load: { key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY }
});
export default {
  name: "AlertDetails",
  components: {
    GmapCustomMarker,
    Icon
  },
  props: {
    alertData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      position: {
        lat: 0,
        lng: 0
      }
    };
  },
  methods: {
    formattedAge(birthday) {
      if (birthday) {
        const date = new Date();
        const currentYear = date.getFullYear();
        const splittedBirthday = birthday.split("-");
        return `${currentYear - parseFloat(splittedBirthday)} Anos`;
      }
      return birthday;
    },
    formattedWeight(weight) {
      return weight ? `${weight}Kg` : weight;
    },
    formattedHeight(height) {
      return height ? `${height}m` : height;
    },
    patientRisk(patient) {
      return patient.higher_risk ? "Sim" : "Não";
    },
    userPhoto(photo) {
      return photo
        ? `background-image: url(${photo});`
        : `background-image: url(${require("./../assets/images/doctor-img.jpg")});`;
    },
    alertLocation(data) {
      return {
        lat: parseFloat(data.lat),
        lng: parseFloat(data.long)
      };
    }
  }
};
</script>
